<template>
  <div>
    <div class="ui tabular menu">
      <a class="item" :class="{ active: currentTab === tabs.first }"
              @click="currentTab = tabs.first">
        Available
      </a>
      <a class="item" :class="{ active: currentTab === tabs.second }"
              @click="currentTab = tabs.second">
        Completed
      </a>
    </div>
    <div style="margin-top: 20px">
      <table class="ui very compact center aligned celled table" v-if="Object.keys(computedPackages()).length > 0">
        <thead>
          <tr> 
            <th>Reservation id</th>
            <th>Name</th>
            <th>Total quantity</th>
            <th>Quantity remainder</th>
            <th>Debit</th>
          </tr>
        </thead>
        <tbody v-for="reservationId in Object.keys(computedPackages())" :key="reservationId">
          <tr 
            v-for="(computedPackage,index) in computedPackages()[reservationId]"
            :key="index"
          >
            <td v-if="index === 0" :rowspan="computedPackages()[reservationId].length"> 
              <a class="id-link" @click="goToReservation(reservationId)">{{ reservationId }} </a> 
            </td>
            <td style="border-left: 1px solid rgba(34,36,38,.1)"> {{ computedPackage.name }} </td>
            <td> {{ computedPackage.totalQuantity }} </td>
            <td :class="{positive: computedPackage.remainderQuantity > 0}"> {{ computedPackage.remainderQuantity }} </td>
            <td :class="{negative: computedPackage.debit > 0 }"> {{ formatPrice(computedPackage.debit) }} </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <div class="ui placeholder segment" style="margin-bottom: 50px">
          <div class="ui icon header" style="color: #092442">
            <i class="dont icon"></i>
            No packages {{ currentTab }}
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    reservations: { type: Array, required: true },
    transactions: { type: Array, default: () => [] },
    visits: { type: Array, required: true }
  },
  data() {
    return {
      tabs: {
        first: 'available',
        second: 'completed'
      },
      currentTab: 'available'
    }
  },
  computed: {
    packagesColumns () {
      return [
        { header: 'Name', fieldName: 'name', show: true, width: '15%' },
        { header: 'Description', fieldName: 'description', show: true },
        { header: 'Unit Price', fieldName: 'unitPrice', show: true, classes: 'positive' },
        { header: 'Quantity', fieldName: 'quantity', show: true },
        { header: 'Package Price', fieldName: 'packagePrice', show: true, classes: 'positive' },
        { header: 'Repeated', fieldName: 'repeated', show: true },
        { header: 'Total Price', fieldName: 'totalPrice', show: true, classes: 'positive' },
        { header: 'Remainder Quantity', fieldName: 'remainder', show: true }
      ]
    }
  },
  methods: {
    computedPackages () {
      let formlatePackages = {}
      const reservationsPackages = () => this.reservations.flatMap(reservation => {
        if (!reservation.cancelled_at) {
          return reservation.reservations_packages
        }
      }).filter(rp => rp !== undefined)

      window._.each(reservationsPackages(), reservationPackage => {
        const formattedReservationPackages = formlatePackages[reservationPackage.reservation_id] || []
        
        const totalQuantity = Number(reservationPackage.repeated) * Number(reservationPackage.package.quantity)
        const totalUsedQuantity = 
          this.totalPackageUsedQuantityForReservation(reservationPackage.reservation_id, reservationPackage.package_id)
        const remainder = Number(totalQuantity) - Number(totalUsedQuantity)
        const totalPrice = totalQuantity * Number(reservationPackage.package.unit_price)
        const debit = totalPrice - this.totalTransactionForPackage(reservationPackage)
        if (this.isSatisfyCurrentTabCondition(remainder)) {
          formattedReservationPackages.push({
            name: reservationPackage.package.name,
            quantity: reservationPackage.package.quantity,
            repeated: reservationPackage.repeated,
            totalQuantity: totalQuantity,
            remainderQuantity: remainder,
            debit: debit >= 0 ? debit : 0 
          })
          formlatePackages[reservationPackage.reservation_id] = formattedReservationPackages
        }
      })

      return formlatePackages
    },
    totalTransactionForPackage(reservationPackage) {
      const reservation = this.reservations.find(reservation => reservation.id === reservationPackage.reservation_id)
      const transactionIds = reservation.reservation_transactions
        .filter(rt => rt.package_id === reservationPackage.package_id)
        .map(rt => rt.transaction_id)
        
      return window._.sumBy(this.transactions, transaction => {
        return transactionIds.includes(transaction.id) ? transaction.amount : 0
      })
    },
    totalPackageUsedQuantityForReservation(reservationId, packageId) {
      const visitsIds = this.reservations
        .flatMap(reservation => reservation.reservation_visits)
        .filter(reservationVisit => reservationVisit.reservation_id === reservationId)
        .map(reservationVisit => reservationVisit.visit_id)

      const notCancelledVisits = this.visits.filter (visit => visit.visit_status_id != this.VisitStatuses.CANCELLED)
      
      return window._.sumBy(notCancelledVisits, visit => {
        if (visitsIds.includes(visit.id)) {
          const visitDetail = visit.visit_details.find(visitDetail => visitDetail.package_id === packageId)
          return visitDetail ? Number(visitDetail.quantity) : 0
        }
        return 0
      })
    },
    isSatisfyCurrentTabCondition(remainder) {
      return this.currentTab === this.tabs.first ?
        remainder > 0 : remainder === 0
    },
    goToReservation(reservationId) {
      this.navigateTo(`Show_Reservation`, {
        key: 'params',
        value: { id: reservationId }
      })
    }
  },
}
</script>

<style scoped>
  .id-link {
    cursor: pointer; 
    text-decoration:underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/applications_components/Packages.vue